import { z } from 'zod';
import { decimalString, optionalText } from './form-helpers';

export const fxCloseFormSchema = z.object({
  closeQuantity: decimalString,
  executedRate: decimalString,
  valueDate: z.string().min(1, 'Required'),
  contractReference: optionalText(200),
  notes: optionalText(1000),
});

export type FxCloseFormValues = z.infer<typeof fxCloseFormSchema>;
